'use strict';
import { db } from './firebase'

import {
    collection,
    addDoc,
    query,
    where,
    getDocs,
    updateDoc,
    doc,
} from "firebase/firestore";

const createInvite = async (data: any) => {
    await addDoc(collection(db, "invites"), data);
};

const getInvitesSent = async (user_uid: string, project_id: string) => {
    const q = query(
        collection(db, `invites`),
        where("user_uuid_from", "==", user_uid),
        where("project_uuid", "==", project_id)
    );

    const data: any = [];

    const querySnapshot = await getDocs(q);

    if (querySnapshot) {
        querySnapshot.forEach((doc) => {
            data.push(doc.data());
        });
    }

    return data
};

const getInvitesRecived = async (user_uid: string) => {
    const q = query(
        collection(db, `invites`),
        where("user_uuid_to", "==", user_uid)
    );

    const data: any = [];

    const querySnapshot = await getDocs(q);

    if (querySnapshot) {
        querySnapshot.forEach((doc) => {
            data.push(doc.data());
        });
    }

    return data
};

const acceptInvite = async (id: string) => {

    const q = query(
        collection(db, `invites`),
        where("id", "==", id),
    );

    const querySnapshot = await getDocs(q);
    const document = doc(db, "invites", querySnapshot.docs[0].id);

    await updateDoc(document, { status: 'accepted' })
};

const rejectInvite = async (id: string) => {

    const q = query(
        collection(db, `invites`),
        where("id", "==", id),
    );

    const querySnapshot = await getDocs(q);
    const document = doc(db, "invites", querySnapshot.docs[0].id);

    await updateDoc(document, { status: 'rejected' })
};

const addUserToProject = async (invite: any) => {

    const q = query(
        collection(db, `projects`),
        where("project_id", "==", invite.project_uuid),
    );

    const querySnapshot = await getDocs(q);
    const document = doc(db, "projects", querySnapshot.docs[0].id);

    await updateDoc(document, { user_uuid: [...querySnapshot.docs[0].data().user_uuid, invite.user_uuid_to] })
};

export {
    createInvite,
    getInvitesSent,
    getInvitesRecived,
    acceptInvite,
    addUserToProject,
    rejectInvite,
};
